import './Login.css';
import Buttons from '../../Components/Buttons/Buttons';
import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Header from '../../Components/Header/Header';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useApi } from "../../Services/api";
import Popup from '../../Components/Popup/Popup';
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import { isMobile } from 'react-device-detect';

const Login = () => {
  const [email, setEmail] = useState('');
  const [resetEmail, setResetEmail] = useState('');
  const [resetEmailError, setResetEmailError] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showForgetPswPopup, setShowForgetPswPopup] = useState(false);
  const [showResetPswPop, setShowResetPswPop] = useState(false);
  const [showResetSuccess, setShowResetSuccess] = useState(false);
  const [pwdResetRequestId, setPwdResetRequestId] = useState();
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationCodeError, setVerificationCodeError] = useState(''); 
  const [resetPsw, setResetPsw] = useState(''); 
  const [resetPswError, setResetPswError] = useState(''); 
  const [resetConfirmPsw, setResetConfirmPsw] = useState(''); 
  const [resetConfirmPswError, setResetConfirmPswError] = useState(''); 
  const [submitResetError, setSubmitResetError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showMobilePopup, setShowMobilePopup] = useState(false);


  const { setErrorVisible, setErrorMessage, setVoyceToken, setRemember } = useGlobalState();

  const navigate = useNavigate();
  const api = useApi();

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    let isValid = true;
    
    // Temporarily don't allow login on mobile
    if (isMobile) {
      setShowMobilePopup(true);
      return;
    }
  
    if (!email) {
      setEmailError('required field');
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailError('invalid!');
        isValid = false;
      } else {
        setEmailError('');
      }
    }
  
    if (!password) {
      setPasswordError('required field');
      isValid = false;
    } else {
      setPasswordError('');
    }
  
    if (isValid && form.checkValidity() !== false) {
      const login = async () => {
        const loginBody = {
          Email: email,
          Password: password
        }
        try {
          const raw = await api.post(`Client/Login/${1}`, loginBody);
          const loginData = raw.data;
          // if loginData.company !== 0:
          // popup error message
          // if (loginData.Company !== 0) {
          //   setErrorVisible(true);
          //   setErrorMessage('Invalid Company');
          // } else 
          if (loginData.Success !== false) {
            setRemember(rememberMe);
            setVoyceToken(loginData.Token);
            navigate('/');
          } else {
            setErrorVisible(true);
            setErrorMessage(loginData.Error);
          }
        } catch (error) {
          console.log("error:", error);
        }
      }
      login();
      
    } else {
      setSubmitted(true);
    }
  };
  

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleForgetPsw = () => {
    setShowForgetPswPopup(true);
  }

  const handleClose = async () => {
    setShowForgetPswPopup(false);
    setShowResetPswPop(false);
    setShowResetSuccess(false);
    setShowMobilePopup(false);
  }
  

  const handleEmailContinue = async() => {
    if (!resetEmail) {
      setResetEmailError('required field');
    } else {
      const resetRequestBody = {
        Email: resetEmail,
        NotificationOptionCodeId: 1,
        CompanyCode: "VoyceInterpreter",
      }
      try {
        const resetRequestData = await api.post(`Client/PasswordResetRequest/${1}`, resetRequestBody);
        const pwdResetRequestId =  resetRequestData.data.PwdResetRequestId;
        setPwdResetRequestId(pwdResetRequestId);
        setShowResetPswPop(true);
        setShowForgetPswPopup(false);
      } catch (error) {
        console.log("error:", error);
      }
    } 
  }

  const handleResetSubmit = async () => {
    setSubmitted(true);
    setVerificationCodeError(verificationCode ? '' : 'required');
    setResetPswError(resetPsw ? '' : 'required');
    setResetConfirmPswError(resetConfirmPsw ? '' : 'required');
    if(resetPsw !== resetConfirmPsw){
      setResetConfirmPswError('passwords do not match! ');
      return;
    }
    // if (verificationCode && resetPsw && resetConfirmPsw && resetPsw === resetConfirmPsw) {
    //   setShowResetPswPop(false);
    // }
    if (verificationCodeError || resetPswError || resetConfirmPswError) {
      return;
    }

    const pswResetBody = {
      PwdResetRequestId: pwdResetRequestId,
      VerificationCode: verificationCode,
      Pwd: resetPsw,
    }
    try {
      const raw = await api.post(`Client/PasswordReset/${1}`, pswResetBody);
      const resetData = raw.data;
      if (resetData.Success === false) {
        setResetPswError(resetData.Error);
        setSubmitResetError(resetData.Error);
      } else {
        setShowResetPswPop(false);
        setShowResetSuccess(true);
      }
    } catch(error) {
      console.log('error:', error);
      setShowResetPswPop(false);
    }
  }

  return (
    <>
      <Header />
      <div className='login-container'>
        <div className='login-text'>Login</div>
        <Form className="form-content" onSubmit={handleSubmit} noValidate>
          <Form.Group as={Col} controlId="emailForm">
            <div className="form-group-inline login-label">
              <Form.Label>Email Address</Form.Label>
              {submitted && emailError && (
                <div className="invalid-feedback" style={{ display: 'block' }}>{emailError}</div>
              )}
            </div>
            <Form.Control
              required
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (submitted) {
                  setEmailError('');
                }
              }}
              className="step-inputBox"
            />
          </Form.Group>

          <Form.Group as={Col} controlId="passwordForm">
            <div className="form-group-inline login-label">
              <Form.Label>Password</Form.Label>
              {submitted && passwordError && (
                <div className="invalid-feedback" style={{ display: 'block' }}>{passwordError}</div>
              )}
            </div>
            <div className="password-container" style={{ position: 'relative' }}>
              <Form.Control
                required
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (submitted) {
                    setPasswordError('');
                  }
                }}
                className="step-inputBox"
              />
              <i
                onClick={togglePasswordVisibility}
                className={showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer'
                }}
              ></i>
            </div>
          </Form.Group>
          <div className="additional-container">
            <Form.Check className="remember-me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              label={
                <>
                  Remember me
                </>
              }
            />
            <div className='forgot-pwd underline'>
              <button
                onClick={handleForgetPsw}
                type="button"
                className='Login-forgot-pwd-text'
              >
                Forgot password?
              </button>
            </div>
          </div>
          

          <div className='Login-btn-container'>
            <Buttons />
          </div>
        </Form>

        {showForgetPswPopup && (
          <Popup 
            show={showForgetPswPopup}
            handleClose={handleClose}
            title={'Reset Your Password'}
            titleStyle="popup-title"
            body={
              <>
                <p>Enter your email address and we will send you a verification code to reset your password.</p>
                <Form.Group as={Col} controlId="firstNameForm">
                  <div className="UserSignUp-form-group-inline">
                    <Form.Label>Email Address</Form.Label>
                  </div>
                  <Form.Control
                    required
                    type="text"
                    value={resetEmail}
                    onChange={(e) => {
                      setResetEmail(e.target.value);
                      if (e.target.value) setResetEmailError('');
                    }}
                    style={{
                      boxShadow: resetEmailError ? '0 0 5px red' : 'none',
                      borderColor: resetEmailError ? 'red' : ''
                    }}
                    className='Login-resetEmail-pop-inputBox'
                  />
                  {resetEmailError && <div className="UserSignUp-invalid-enterOTP">{resetEmailError}</div>}
                </Form.Group>
                <div className="Login-resetEmail-pop-btn">
                  <Buttons handleSubmit={handleEmailContinue} />
                </div>
              </>
            }
          />
        )}
        {showResetPswPop && (
          <Popup 
            show={showResetPswPop}
            handleClose={handleClose}
            title={'Please Reset Your Password'}
            titleStyle="popup-title"
            body={
              <>
                {submitted && submitResetError && (
                  <div className="invalid-feedback" style={{ display: 'block' }}>{submitResetError}</div>
                )}
                <div className='Login-text'>We've sent a Verification Code to the email <b>{resetEmail}.</b> Please enter it below.</div>
                <Form>
                  <Form.Group as={Col} controlId="verificationCodeForm">
                    <div className="form-group-inline login-label">
                      <Form.Label>Verification Code</Form.Label>
                      {submitted && verificationCodeError && (
                        <div className="invalid-feedback" style={{ display: 'block' }}>{verificationCodeError}</div>
                      )}
                    </div>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter your Verification Code"
                      value={verificationCode}
                      onChange={(e) => {
                        setVerificationCode(e.target.value);
                        if (submitted) {
                          setVerificationCodeError('');
                        }
                      }}
                      className="step-inputBox"
                    />
                  </Form.Group>

                  <Form.Group as={Col} controlId="newPasswordForm">
                    <div className="form-group-inline login-label">
                      <Form.Label>New Password</Form.Label>
                      {submitted && resetPswError && (
                        <div className="invalid-feedback" style={{ display: 'block' }}>{resetPswError}</div>
                      )}
                    </div>
                    <div className="password-container" style={{ position: 'relative' }}>
                      <Form.Control
                        required
                        type={showPassword ? "text" : "password"}
                        placeholder="New Password"
                        value={resetPsw}
                        onChange={(e) => {
                          setResetPsw(e.target.value);
                          if (submitted) {
                            setResetPswError('');
                          }
                        }}
                        className="step-inputBox"
                      />
                      <i
                        onClick={togglePasswordVisibility}
                        className={showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer'
                        }}
                      ></i>
                    </div>
                  </Form.Group>

                  <Form.Group as={Col} controlId="confirmPasswordForm">
                    <div className="form-group-inline login-label">
                      <Form.Label>Confirm Password</Form.Label>
                      {submitted && resetConfirmPswError && (
                        <div className="invalid-feedback" style={{ display: 'block' }}>{resetConfirmPswError}</div>
                      )}
                    </div>
                    <div className="password-container" style={{ position: 'relative' }}>
                      <Form.Control
                        required
                        type={showPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        value={resetConfirmPsw}
                        onChange={(e) => {
                          setResetConfirmPsw(e.target.value);
                          if (submitted) {
                            setResetConfirmPswError('');
                          }
                        }}
                        className="step-inputBox"
                      />
                      <i
                        onClick={togglePasswordVisibility}
                        className={showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer'
                        }}
                      ></i>
                    </div>
                  </Form.Group>
                </Form>
                <div className='reset-btn'>
                <Buttons back={'Back'} handleBack={() => {
                  setShowResetPswPop(false);
                  setShowForgetPswPopup(true);
                }} handleSubmit={handleResetSubmit}  text={'Done'}/>
                </div>
              </>
            }
          />
        )}
        {showResetSuccess && (
          <Popup 
            show={showResetSuccess}
            handleClose={handleClose}
            title={'Password Reset Successful'}
            titleStyle="popup-title"
            body={
              <>
                <p>Your password has been successfully reset. Please login with your new password.</p>
                <div className='Login-checkEmail-pop-btn'>
                  <Buttons text={'Done'} handleSubmit={handleClose} />
                </div>
              </>
            }
          />
        
        )}
        {showMobilePopup && (
          <Popup 
            show={showMobilePopup}
            handleClose={handleClose}
            title={'Mobile Login Not Supported'}
            titleStyle="popup-title"
            body={
              <>
                <p>We do not currently support logging in through mobile devices. Please use a desktop or laptop to log in.</p>
                <div className='Login-checkEmail-pop-btn'>
                  <Buttons text={'OK'} handleSubmit={handleClose} />
                </div>
              </>
            }
          />
        )}

        <div className='bottom-text'>
        New to Voyce?
          <span
            onClick={() => navigate('/CompanySignUp')}
            className='signUp underline'
          >
              Sign up now
          </span>
        </div>
      </div>
    </>
  );
};

export default Login;
